import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="bg-navy" data-id="element-91" data-mp="4lqkp0lrnl5m">
      <div className="mx-auto flex max-w-page flex-col items-center px-3 pb-6 pt-4 text-center sm:px-6 sm:pb-8" data-id="element-92" data-mp="4mrul1r1q1lr">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="rounded-full border border-gold/40 bg-gold/10 px-3 py-1 text-[0.62rem] font-extrabold uppercase tracking-[0.2em] text-gold sm:text-[0.7rem]" data-id="element-93" data-mp="1286262e70it6">
          📘 Método de aprendizaje paso a paso
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.04
      }} className="mt-2 max-w-4xl font-display text-[1.35rem] font-black leading-[1.08] text-white sm:text-4xl lg:text-[2.9rem]" data-id="element-94" data-mp="3d2bjxpolizvj">
          El sistema completo para aprender{' '}
          <span className="text-gold" data-id="element-95" data-mp="39alaige2es47">inglés esencial desde cero</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.08
      }} className="mt-1.5 max-w-2xl text-[0.8rem] font-medium leading-snug text-white sm:text-[0.95rem]" data-id="element-96" data-mp="3e9fq79gqk0k3">
          Aprende las bases del inglés, comienza a comunicarte en situaciones
          cotidianas y construye confianza — sin perderte entre cientos de
          videos, aplicaciones y tutoriales.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.11
      }} className="mt-2 rounded bg-royal px-3 py-1 text-[0.66rem] font-extrabold uppercase tracking-wide text-white sm:text-[0.8rem]" data-id="element-97" data-mp="2hj5i25ptub62">
          📘 {PRODUCT} · 6 Módulos + 5 Bonos
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.14
      }} className="mt-2 block w-full max-w-lg" data-id="element-98" data-mp="n98dxp26z7of">
          <img src={PACK_IMAGE} alt={`${PRODUCT}: 6 módulos digitales y 5 bonos incluidos`} className="mx-auto w-full rounded-lg" data-id="element-99" data-mp="1azkvlrn8ois7" />
        </motion.a>

        <div className="mt-3 flex w-full flex-col items-center gap-1.5" data-id="element-100" data-mp="111esj6pp56lr">
          <CtaButton size="lg" data-id="element-101" data-mp="x1nxurx1u6by">🚀 SÍ, QUIERO COMENZAR AHORA</CtaButton>
          <p className="flex flex-wrap items-center justify-center gap-x-2 text-[0.64rem] font-bold uppercase tracking-wide text-ivory sm:text-[0.72rem]" data-id="element-102" data-mp="3lsyt309hwojl">
            Acceso Digital Inmediato
            <span aria-hidden="true" data-id="element-103" data-mp="3htpyjt6msmmz">•</span>
            <span className="flex items-center gap-1" data-id="element-104" data-mp="1xacfj35u5jt8">
              <ShieldCheckIcon size={12} className="text-gold" data-id="element-105" data-mp="1x7hvhcqqi10c" />
              Garantía de 7 Días
            </span>
          </p>
        </div>
      </div>
    </header>;
}